"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiErrorMessage = getApiErrorMessage;
const i18next_1 = __importDefault(require("i18next"));
const parseApiError_1 = require("./parseApiError");
function hasTranslation(key) {
    try {
        return i18next_1.default.exists(key);
    }
    catch {
        return false;
    }
}
/**
 * Devuelve el mensaje a mostrar al usuario para un error de API.
 *
 * Si el backend envía un `title` que tenemos traducido (p.ej.
 * "errorUpdateWeightDoor") se muestra ese mensaje concreto; si no,
 * se recurre al mensaje genérico de la acción.
 */
function getApiErrorMessage(t, error, fallbackKey) {
    const { title } = (0, parseApiError_1.parseApiError)(error);
    if (title && hasTranslation(title))
        return t(title);
    return t(fallbackKey);
}
